import { Routes, Route, Link, useMatch, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Loading } from "../../../../../_metronic/elements/Loading";
import CreateNDVIReport from "./CreateNDVIReport";
import ViewNDVI from "./ViewNDVI/ViewNDVI";
import Report from "./Report";
import { NDVIReportProvider, useNDVIReportContext } from "./NDVIReportContext";
import { KTSVG } from "../../../../../_metronic/helpers";
import { useIsMobile } from "../../../../shared/responsive";

const NDVIReport = () => {
  const { t } = useTranslation();
  const { loading, reports } = useNDVIReportContext();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isCreateMobile = useMatch("/gis/reports/ndvi/new");
  const isViewMobile = useMatch("/gis/reports/ndvi/view/:id");

  const nestedRoutes = (
    <Routes>
      <Route path="new" element={<CreateNDVIReport />} />
      <Route path="view/:id" element={<ViewNDVI />} />
    </Routes>
  );

  if (isMobile) {
    if (isCreateMobile || isViewMobile) {
      return nestedRoutes;
    }

    return (
      <>
        <div className="reports-mobile-shell displayable">
          <div className="card shadow-sm right-card-data reports-mobile-card">
            <div className="reports-mobile-card__header">
              <button
                type="button"
                className="btn btn-sm btn-light reports-mobile-card__back"
                onClick={() => navigate("/gis/reports")}
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr063.svg"
                  className="svg-icon svg-icon-2"
                />
                <span>{t("common:navigation.back_reports")}</span>
              </button>
              <div className="reports-mobile-card__eyebrow">{t("reports:selector.report_label")}</div>
              <h2 className="reports-mobile-card__title">{t("reports:selector.ndvi_report")}</h2>
              <button
                type="button"
                className="btn btn-sm btn-primary reports-mobile-card__primary-action"
                onClick={() => navigate("/gis/reports/ndvi/new")}
              >
                {t("reports:ndvi.list.buttons.create")}
              </button>
            </div>
            <div className="reports-mobile-card__body">
              {loading && (
                <div className="reports-mobile-card__state">
                  <Loading />
                </div>
              )}
              {!loading && reports.length < 1 && (
                <div className="reports-mobile-card__empty">
                  {t("reports:ndvi.list.no_reports")}
                </div>
              )}
              {!loading && reports.map((r) => {
                return <Report key={r.id} report={r} />
              })}
            </div>
          </div>
        </div>
        {nestedRoutes}
      </>
    );
  }

  return (
    <>
      <div className="card shadow-sm field-view-container displayable right-card-data ndvi-report-list-card">
        <div className="card-header collapsible ndvi-report-list-card__header">
          <div className="ndvi-report-list-card__heading">
            <button
              type="button"
              className="btn btn-sm btn-light reports-mobile-card__back ndvi-report-list-card__back"
              onClick={() => navigate("/gis/reports")}
            >
              <KTSVG
                path="/media/icons/duotune/arrows/arr063.svg"
                className="svg-icon svg-icon-2"
              />
              <span>{t("common:navigation.back_reports")}</span>
            </button>
            <h4 className="card-title cursor-pointer ndvi-report-list-card__title" data-bs-toggle="collapse" data-bs-target="#kt_view_land_collapsible">
              {t("reports:selector.ndvi_report")}
            </h4>
          </div>
          <div className="card-toolbar">
            <Link to={"/gis/reports/ndvi/new"} className="btn btn-sm btn-light-primary gis-toolbar-action">
              {t("reports:ndvi.list.buttons.create")}
            </Link>
          </div>
        </div>
        <div id="kt_view_land_collapsible" className="collapse show">
          <div className={"card-body " + ((reports.length < 1 || loading) ? "p-5" : "p-0")}>
            {loading && <Loading />}
            {!loading && reports.length < 1 && (
              <p className="m-0 reports-empty-state">{t("reports:ndvi.list.no_reports")}</p>
            )}
            {reports.map(r => {
              return <Report key={r.id} report={r} />
            })}
          </div>
        </div>
      </div>
      {nestedRoutes}
    </>
  );
};

const NDVIReportModule = () => {
  return (
    <NDVIReportProvider>
      <div className="d-flex flex-column flex-row-auto field-view-flex-container">
        <div className="d-flex flex-column-auto">
          <NDVIReport />
        </div>
      </div>
    </NDVIReportProvider>
  );
};

export default NDVIReportModule;
